import { createStoreCreator } from 'lib/store'
import reducer from 'reports/stoppageTrend/reducers'

export default createStoreCreator(reducer)
